<template>
    <div>
      <nav-breadcrumb :menu="[{label: '退款对账'}]"/>
      <el-row class="xzpadd10 bg-purple">
        <el-row>
          <el-button type="primary">导出</el-button>
        </el-row>
      </el-row>
    </div>
</template>

<script>
    export default {
        name: "FinanceCashJournalRefundList"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/lender/Finance/FinanceCashJournalRefundList.vue